/** Format integer to "Rp 1.234.567" */
export function formatIDR(n) {
  if (n == null || isNaN(n)) return "Rp 0";
  return "Rp " + Number(n).toLocaleString("id-ID");
}

/** Parse "Rp 1.234.567" or "1234567" or with spaces/dots into a plain number. */
export function parseIDR(s) {
  if (s == null) return 0;
  const cleaned = String(s).replace(/[^\d]/g, "");
  return cleaned === "" ? 0 : parseInt(cleaned, 10);
}

export function formatDateID(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) {
      // maybe date-only "YYYY-MM-DD"
      const parts = iso.split("-");
      if (parts.length === 3) {
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }
      return iso;
    }
    return d.toLocaleDateString("id-ID", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch (_e) { return iso; }
}
